import './SmartMatchBadge.css';

export const SmartMatchBadge = ({ match, compact = false, showReasons = true }) => {
  if (!match?.score) return null;
  const tier = match.tier || 'low';

  if (compact) {
    return (
      <span className={`smart-match-inline smart-match-inline--${tier}`}>
        <span className={`smart-match-badge__dot`} style={{ width: 8, height: 8 }} />
        {match.score}% Match
      </span>
    );
  }

  return (
    <div className={`smart-match-badge smart-match-badge--${tier}`}>
      <div className="smart-match-badge__score-row">
        <span className="smart-match-badge__dot" aria-hidden="true" />
        <span className="smart-match-badge__percent">{match.score}% Match</span>
      </div>
      {match.headline && <p className="smart-match-badge__headline">{match.headline}</p>}
      {showReasons && match.reasons?.length > 0 && (
        <ul className="smart-match-badge__reasons">
          {match.reasons.map((r) => (
            <li key={r}>{r}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const SmartMatchPanel = ({ match }) => {
  if (!match?.score) return null;
  const tier = match.tier || 'low';
  const ringColor = tier === 'high' ? '#22c55e' : tier === 'medium' ? '#f59e0b' : '#94a3b8';

  return (
    <section className={`smart-match-panel smart-match-panel--${tier}`} aria-label="Why this property matches you">
      <h2 className="smart-match-panel__title">Why This Property Matches You</h2>
      <div className="smart-match-panel__header">
        <div
          className="smart-match-ring"
          style={{ '--pct': match.score, '--ring-color': ringColor }}
          aria-hidden="true"
        >
          <span>{match.score}%</span>
        </div>
        <div>
          <p className="smart-match-panel__subtitle">{match.headline}</p>
          <p style={{ margin: '4px 0 0', fontSize: '0.85rem', color: '#64748b' }}>
            This stay aligns with your preferences because:
          </p>
        </div>
      </div>
      {match.reasons?.length > 0 && (
        <ul className="smart-match-panel__reasons">
          {match.reasons.map((r) => (
            <li key={r}>{r}</li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default SmartMatchBadge;
